import { Component, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-multiselect-dropdown',
  standalone: true,
  templateUrl: './multiselect-dropdown.component.html',
  styleUrls: ['./multiselect-dropdown.component.css']
})
export class MultiselectDropdownComponent {

  @Input() options: string[] = [];
  @Input() title = '';
  @Output() selectionChange = new EventEmitter<string[]>();

  selectedOptions: string[] = [];
  dropdownOpen = false;

  constructor(private eRef: ElementRef) {}

  toggleSelection(option: string) {
    const index = this.selectedOptions.indexOf(option);
    if (index === -1) {
      this.selectedOptions.push(option);
    } else {
      this.selectedOptions.splice(index, 1);
    }
  }

  isSelected(option: string): boolean {
    return this.selectedOptions.includes(option);
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    if (!this.dropdownOpen) {
      this.returnSelectedItems();
    }
  }

  closeDropdown() {
    this.dropdownOpen = false;
    this.returnSelectedItems();
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    if (this.dropdownOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  returnSelectedItems(): void {
    this.selectionChange.emit(this.selectedOptions);
  }

  clearSelection(event: Event): void {
    event.stopPropagation();
    this.selectedOptions = [];
    this.returnSelectedItems();
  }
}